export default "__VITE_ASSET__Dt$6QPRy__"